import { Instagram, Youtube, MessageCircle, Mail } from "lucide-react";
import { NAV_LINKS } from "@/data/content";
import { Wordmark } from "@/components/Wordmark";

const SOCIALS = [
  { label: "Instagram", href: "https://instagram.com/capable360", Icon: Instagram },
  { label: "YouTube", href: "https://youtube.com/@capable360", Icon: Youtube },
  { label: "WhatsApp", href: "https://wa.me/919811783739", Icon: MessageCircle },
  { label: "Email", href: "mailto:hello@capable360.in", Icon: Mail },
];

export default function Footer() {
  return (
    <footer id="contact" data-testid="footer" className="bg-ink border-t border-zinc-800 px-5 sm:px-10 lg:px-16 pt-20 pb-10">
      <div className="flex flex-col lg:flex-row justify-between gap-12">
        <div>
          <Wordmark className="text-[16vw] sm:text-[9vw] lg:text-[7vw] leading-[0.85] block" />
          <p className="mt-4 font-display uppercase tracking-[0.2em] text-volt text-xl sm:text-2xl">
            Capable 360 — Train for life.
          </p>
        </div>

        <div className="flex gap-16 lg:gap-24">
          <nav className="flex flex-col gap-3">
            <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-600 mb-2">Navigate</span>
            <a href="#top" data-testid="footer-link-home" className="text-sm uppercase tracking-[0.14em] font-semibold text-zinc-300 hover:text-volt transition-colors">Home</a>
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm uppercase tracking-[0.14em] font-semibold text-zinc-300 hover:text-volt transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex flex-col gap-3">
            <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-600 mb-2">Connect</span>
            {SOCIALS.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="flex items-center gap-3 text-sm uppercase tracking-[0.14em] font-semibold text-zinc-300 hover:text-volt transition-colors"
              >
                <Icon size={16} /> {label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-zinc-800/70 flex flex-wrap justify-between gap-3 text-[10px] uppercase tracking-[0.2em] text-zinc-600">
        <span>© {new Date().getFullYear()} Capable 360. All rights reserved.</span>
        <span>Movement + Strength + Mobility + Athleticism</span>
      </div>
    </footer>
  );
}
